import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation, useNavigate, Navigate } from 'react-router-dom';
import { ethers } from 'ethers';

import AppLayout from "../components/Layaout/AppLayout";

// Navbars y layout
import Navigation from '../components/NavBar/Navbar';
import Footer from '../components/Layaout/Footer';
import AuthenticatedNav from '../components/NavBar/AuthenticatedNav';

// Pages públicas
import Home from './Home';
import Treaning from './Traning';
import NFTCollection from './NFTCollection';
import Roadmap from './Roadmap';
import RegistrationComponent from './Registration';
import AboutUs from './AboutUs';
import Guia from './guia';
import VideoGuide from './Videos';
import Bot from "./BotInteligente";

// Pages privadas
import Profile from './Profile';
import Course from './ComponentCourse';
import Create from './Create';
import MyListedItems from './MyListedItems';
import MyPurchases from './MyPurchases';
import TradingTerminal from './ToolsTreading';
import CyptoTools from './CyptoTools';
import MainPage from './MintNft';
import Museum from './Museum';
import IframeRenderer from "./IframeCourseRender";
import HomeContractManager from "./HomeContractManager";
import VideoComponet from "./VideoIframe";
import ChatBotButton from "./BotPage";
import BlockchainSimulator from './BlockchainSimulator';

// Data
import URLCourse from '../data/URLCourse.json'
import Projects from './Projects';

import TokenViewer from "./proyectViewer";
import BootCapsVi from "./BootcamsView";
import SolidityBo from "./SolidityViewer"
import PDFUploader from "../components/Load/summitPDF"

// Certificado 
import Certificate from '../components/Certificates/CertificateGenerator'

// Coming soon
import ComingSoon from './ComingSoon';

// Simuladores 
import Simuladores from './Simuladores';
import HashSimulator from '../components/P2P/HashSimulator';
import BlockSimulator from '../components/P2P/BlockchainSimulation';
import BlockSimulatorNetwork from '../components/P2P/BlockchainNetwork';
import TxChainSimulator from '../components/P2P/TxChainSimulator';
import GasPriorityChain from '../components/P2P/GasPriorityChain';
import MerkleMempoolSimulation from '../components/P2P/MerkleMempoolSimulation';
import Billeteras from '../components/P2P/AddressValidator';

import LessonView from "./LessonView";
import Books from "./Books";
import BookDetail from "./BookDetail";
import Reader from "./Reader";
import FiveClassesViewer from './ClaseView'
import RedirectToFirstClass from "./RedirectToFirstClass";

// Books 
import ContentViewerSolidity from "./ContentViewerSolidity";
import ContentViewerBlockchain from "./ContentViewerBlockchain";
import ContentViewerTokens from "./ContentViewerTokens";
import ContentViewerCryptonomics from "./ContentViewerCryptonomics";
import ContentViewerSatoshi from "./ContentViewerSantochi";
import ContentViewerDarkForest from "./ContentViewerBlockchainDarkForest"
import ContentViewerBlockchainEsencial from "./ContentViewerBlockchainEsencial"
import ContentViewerBitcoinMaster from "./ContentViewerBitcoinMaster"
import ContentViewerCryptomonedas from "./ContentViewerCryptomonedas"
import BookPage from "./BookPage";


// Certificados 
import PDF from "./certificadosmit";
import NFTC from "./CheckWalletNFTCard";
import NFTCo from "./MyNFTCollections";

import MarketplaceAbi from '../contractsData/Marketplace.json';
import MarketplaceAddress from '../contractsData/Marketplace-address.json';
import NFTAbi from '../contractsData/NFT.json';
import NFTAddress from '../contractsData/NFT-address.json';

// Directorio
import CryptoDictionaryABC from "./CryptoDictionaryABC";


//QUIZ 
import QuizApp from "./quiz";

import './App.css';
import IdentificationReceiptPage from './IdentificationReceiptPage';

/* ----------------- WRAPPERS DE RUTA ----------------- */
function ProtectedRoute({ account, loading, children }) {
  const location = useLocation();
  // Mientras detectamos sesión no movemos la ruta:
  if (loading) return null;
  if (!account) {
    // Si no hay sesión, mandamos a Home, pero conservamos "from" por si quieres usarlo.
    return <Navigate to="/" replace state={{ from: location.pathname }} />;
  }
  return children;
}

function GuestRoute({ account, loading, children }) {
  if (loading) return null;
  // Si ya hay sesión y entra a una pública (Home/Register), lo llevamos al perfil
  return !account ? children : <Navigate to="/course/profile" replace />;
}

/* ----------------- APP ----------------- */
function AppWrapper() {
  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}

function App() {
  const location = useLocation();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [account, setAccount] = useState(null);
  const [nft, setNFT] = useState({});
  const [marketplace, setMarketplace] = useState({});
  const [isEmailVerified, setIsEmailVerified] = useState(false);
  const [mostrarAlerta, setMostrarAlerta] = useState(false);
  const [alertaYaVista, setAlertaYaVista] = useState(false);

  // === Restaurar sesión al cargar (no saca de la página al refrescar) ===
  useEffect(() => {
    const restore = async () => {
      try {
        if (window?.ethereum) {
          const accs = await window.ethereum.request({ method: 'eth_accounts' });
          if (accs && accs.length) {
            setAccount(accs[0]);
            const provider = new ethers.providers.Web3Provider(window.ethereum);
            const signer = provider.getSigner();
            await loadContracts(signer);
          }
          // listeners
          window.ethereum.on('chainChanged', () => window.location.reload());
          window.ethereum.on('accountsChanged', async (newAccounts) => {
            if (!newAccounts.length) {
              setAccount(null);
              setLoading(false);
              navigate('/');
            } else {
              setAccount(newAccounts[0]);
              const provider = new ethers.providers.Web3Provider(window.ethereum);
              const signer = provider.getSigner();
              await loadContracts(signer);
            }
          });
        }
      } catch (e) {
        // silenciar
      } finally {
        setLoading(false);
      }
    };
    restore();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const web3Handler = async () => {
    try {
      const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
      setAccount(accounts[0]);

      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();

      window.ethereum.on('chainChanged', () => window.location.reload());
      window.ethereum.on('accountsChanged', async (newAccounts) => {
        if (newAccounts.length === 0) {
          setAccount(null);
          setLoading(false);
          navigate('/');
        } else {
          setAccount(newAccounts[0]);
          loadContracts(signer);
        }
      });

      await loadContracts(signer);

      if (isEmailVerified) {
        navigate('/course/profile');
      }
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (account && !alertaYaVista) setMostrarAlerta(true);
  }, [account, alertaYaVista]);

  const cerrarAlerta = () => {
    setMostrarAlerta(false);
    setAlertaYaVista(true);
  };

  const loadContracts = async (signer) => {
    try {
      const marketplace = new ethers.Contract(MarketplaceAddress.address, MarketplaceAbi.abi, signer);
      setMarketplace(marketplace);
      const nft = new ethers.Contract(NFTAddress.address, NFTAbi.abi, signer);
      setNFT(nft);
    } catch (error) {
      // silenciar
    }
  };

  // Ojo con estos: tienes rutas dinámicas que no van a matchear con equals.
  const noFooterRoutes = [
    "/course/profile", "/course/CDB", "/course/trading-terminal",
    "/course/crypto-tools", "/course/mint-nft", "/course/historia-del-dinero",
    "/course/contract-manager", "/course/videos",

    "/course/introduccion-a-la-blockchain", "/course/blockchain-en-la-industria",
    "/course/historia-del-dinero", "/course/bitcoin-historia",
    "/course/criptomonedas-y-tokens", "/course/mineria-blockchain",
    "/course/criptografia-blockchain", "/course/criptografia-asimetrica",
    "/course/explorando-hash-sha256", "/course/arboles-merkle-blockchain",
    "/course/introduccion-wallets-blockchain", "/course/nft-blockchain",
    "/course/contratos-inteligentes", "/course/desarrollo-dapps-blockchain",
    "/course/aspectos-legales-blockchain", "/course/finanzas-descentralizadas-defi",
    "/course/ia-respuestas", "/course/tools-blockchain", "/course/token-project-viewer",
    "/course/token-project-viewer/pdf",
    "/course/ley-fintech", // prefijo
    "/course/solidity",    // prefijo
    "/course/certificate",
    "/course/bootcamps",
    "/course/coming-soon",
    "/course/simuladores",
    "/course/simulador-hash",
    "/course/simulador-bloques",
    "/course/simulador-red",
    "/course/simulador-tx-chain",
    "/course/simulador-gas",
    "/course/simulador-mempool",
    "/course/simulador-billeteras",
    "/course/books",
    "/course/clases",
    "/course/solidity-book",
    "/course/quiz",
    "/course/fame-projects",
    "/course/mint-certificate",
    "/course/NFT-certificate",
    "/course/my-NFTs",
    "/course/blockchain-fundamentos",
    "/course/token",
    "/course/cryptonomics",
    "/course/bitcoin-growth",
    "/course/dark-forest",
    "/course/blockchain-fundamentos-esenciales",
    "/course/bitcoin-master",
    "/course/criptomonedas-fundamentales",

    "/course/diccionario",
  ];

  const hideFooter = noFooterRoutes.some(p =>
    location.pathname === p ||
    location.pathname.startsWith(`${p}/`)
  );

  const hideChrome =
    location.pathname.startsWith('/identificacion/') ||
    location.pathname.startsWith('/recibos/');

  return (
    <div className='App'>
      {/* Navbar pública solo SIN sesión */}
      {!hideChrome && !account && <Navigation />}
      {/* Navbar autenticada solo CON sesión */}
      {!hideChrome && account && <AuthenticatedNav account={account} setAccount={setAccount} />}

      <div>
        <Routes>
          {/* ---------- PÚBLICAS (solo visitantes) ---------- */}
          <Route
            path="/"
            element={
              <GuestRoute account={account} loading={loading}>
                <Home />
              </GuestRoute>
            }
          />
          <Route
            path="/course/blockchain"
            element={
              <GuestRoute account={account} loading={loading}>
                <Treaning />
              </GuestRoute>
            }
          />
          <Route
            path="/course/NFTs"
            element={
              <GuestRoute account={account} loading={loading}>
                <NFTCollection />
              </GuestRoute>
            }
          />
          <Route
            path="/course/roadmap"
            element={
              <GuestRoute account={account} loading={loading}>
                <Roadmap />
              </GuestRoute>
            }
          />
          <Route
            path="/course/register"
            element={
              <GuestRoute account={account} loading={loading}>
                <RegistrationComponent web3Handler={web3Handler} account={account} />
              </GuestRoute>
            }
          />
          <Route
            path="/course/guia"
            element={
              <GuestRoute account={account} loading={loading}>
                <Guia />
              </GuestRoute>
            }
          />
          <Route
            path="/course/about-us"
            element={
              <GuestRoute account={account} loading={loading}>
                <AboutUs />
              </GuestRoute>
            }
          />
          <Route
            path="/course/acceso"
            element={
              <GuestRoute account={account} loading={loading}>
                <VideoGuide />
              </GuestRoute>
            }
          />
          {/* Si quieres que el bot sea público también: */}
          <Route path="/course/ia-respuestas" element={<Bot />} />

          {/* ---------- RECIBO / IDENTIFICACIÓN PÚBLICA POR TOKEN ---------- */}
          <Route path="/identificacion/:token" element={<IdentificationReceiptPage />} />
          <Route path="/recibos/:token" element={<IdentificationReceiptPage />} />

          {/* ---------- PRIVADAS (requieren sesión) ---------- */}
          <Route
            path="/course/profile"
            element={
              <ProtectedRoute account={account} loading={loading}>
                <Profile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/"
            element={
              <ProtectedRoute account={account} loading={loading}>
                <Profile />
              </ProtectedRoute>
            }
          />

          <Route
            path="/course/CDB"
            element={
              <ProtectedRoute account={account} loading={loading}>
                <Course />
              </ProtectedRoute>
            }
          />
          <Route
            path="/course/trading-terminal"
            element={
              <ProtectedRoute account={account} loading={loading}>
                <TradingTerminal />
              </ProtectedRoute>
            }
          />
          <Route
            path="/course/crypto-tools"
            element={
              <ProtectedRoute account={account} loading={loading}>
                <CyptoTools />
              </ProtectedRoute>
            }
          />
          <Route
            path="/course/mint-nft"
            element={
              <ProtectedRoute account={account} loading={loading}>
                <MainPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/course/museum"
            element={
              <ProtectedRoute account={account} loading={loading}>
                <Museum />
              </ProtectedRoute>
            }
          />
          <Route
            path="/course/contract-manager"
            element={
              <ProtectedRoute account={account} loading={loading}>
                <HomeContractManager />
              </ProtectedRoute>
            }
          />
          <Route
            path="/course/videos"
            element={
              <ProtectedRoute account={account} loading={loading}>
                <VideoComponet />
              </ProtectedRoute>
            }
          />
          <Route
            path="/course/tools-blockchain"
            element={
              <ProtectedRoute account={account} loading={loading}>
                <BlockchainSimulator />
              </ProtectedRoute>
            }
          />
          <Route
            path="/course/fame-projects"
            element={
              <ProtectedRoute account={account} loading={loading}>
                <Projects />
              </ProtectedRoute>
            }
          />
          <Route
            path="/course/bootcamps"
            element={
              <ProtectedRoute account={account} loading={loading}>
                {/* si tienes componente Bootcamp importado arriba */}
                {/* <Bootcamp /> */}
                <div />
              </ProtectedRoute>
            }
          />
          <Route
            path="/course/token-project-viewer/:stepId"
            element={
              <ProtectedRoute account={account} loading={loading}>
                <TokenViewer />
              </ProtectedRoute>
            }
          />
          <Route
            path="/course/ley-fintech/:videoId"
            element={
              <ProtectedRoute account={account} loading={loading}>
                <BootCapsVi />
              </ProtectedRoute>
            }
          />
          <Route
            path="/course/solidity/:videoId"
            element={
              <ProtectedRoute account={account} loading={loading}>
                <SolidityBo />
              </ProtectedRoute>
            }
          />
          <Route
            path="/course/token-project-viewer/pdf"
            element={
              <ProtectedRoute account={account} loading={loading}>
                <PDFUploader />
              </ProtectedRoute>
            }
          />
          <Route
            path="/course/quiz"
            element={
              <ProtectedRoute account={account} loading={loading}>
                <QuizApp />
                <div />
              </ProtectedRoute>
            }
          />

          {/* iframes de contenido */}
          <Route path="/course/introduccion-a-la-blockchain" element={<ProtectedRoute account={account} loading={loading}><IframeRenderer url={URLCourse.introduccionBlockchainURL} /></ProtectedRoute>} />
          <Route path="/course/blockchain-en-la-industria" element={<ProtectedRoute account={account} loading={loading}><IframeRenderer url={URLCourse.blockchainIndustriaURL} /></ProtectedRoute>} />
          <Route path="/course/historia-del-dinero" element={<ProtectedRoute account={account} loading={loading}><IframeRenderer url={URLCourse.historiaDelDineroURL} /></ProtectedRoute>} />
          <Route path="/course/bitcoin-historia" element={<ProtectedRoute account={account} loading={loading}><IframeRenderer url={URLCourse.bitcoinHistoriaURL} /></ProtectedRoute>} />
          <Route path="/course/criptomonedas-y-tokens" element={<ProtectedRoute account={account} loading={loading}><IframeRenderer url={URLCourse.criptomonedasTokensURL} /></ProtectedRoute>} />
          <Route path="/course/mineria-blockchain" element={<ProtectedRoute account={account} loading={loading}><IframeRenderer url={URLCourse.mineriaBlockchainURL} /></ProtectedRoute>} />
          <Route path="/course/criptografia-blockchain" element={<ProtectedRoute account={account} loading={loading}><IframeRenderer url={URLCourse.criptografiaBlockchainURL} /></ProtectedRoute>} />
          <Route path="/course/criptografia-asimetrica" element={<ProtectedRoute account={account} loading={loading}><IframeRenderer url={URLCourse.criptografiaAsimetricaURL} /></ProtectedRoute>} />
          <Route path="/course/explorando-hash-sha256" element={<ProtectedRoute account={account} loading={loading}><IframeRenderer url={URLCourse.explorandoHashSHA256URL} /></ProtectedRoute>} />
          <Route path="/course/arboles-merkle-blockchain" element={<ProtectedRoute account={account} loading={loading}><IframeRenderer url={URLCourse.arbolesMerkleBlockchainURL} /></ProtectedRoute>} />
          <Route path="/course/introduccion-wallets-blockchain" element={<ProtectedRoute account={account} loading={loading}><IframeRenderer url={URLCourse.introduccionWalletsBlockchainURL} /></ProtectedRoute>} />
          <Route path="/course/nft-blockchain" element={<ProtectedRoute account={account} loading={loading}><IframeRenderer url={URLCourse.nftBlockchainURL} /></ProtectedRoute>} />
          <Route path="/course/contratos-inteligentes" element={<ProtectedRoute account={account} loading={loading}><IframeRenderer url={URLCourse.contratosInteligentesURL} /></ProtectedRoute>} />
          <Route path="/course/desarrollo-dapps-blockchain" element={<ProtectedRoute account={account} loading={loading}><IframeRenderer url={URLCourse.desarrolloDappsBlockchainURL} /></ProtectedRoute>} />
          <Route path="/course/aspectos-legales-blockchain" element={<ProtectedRoute account={account} loading={loading}><IframeRenderer url={URLCourse.aspectosLegalesBlockchainURL} /></ProtectedRoute>} />
          <Route path="/course/finanzas-descentralizadas-defi" element={<ProtectedRoute account={account} loading={loading}><IframeRenderer url={URLCourse.finanzasDescentralizadasDefiURL} /></ProtectedRoute>} />

          {/* Certificados y otros */}
          <Route path="/course/certificate" element={<ProtectedRoute account={account} loading={loading}><Certificate /></ProtectedRoute>} />
          <Route path="/course/coming-soon" element={<ProtectedRoute account={account} loading={loading}><ComingSoon /></ProtectedRoute>} />

          {/* Simuladores */}
          <Route path="/course/simuladores" element={<ProtectedRoute account={account} loading={loading}><Simuladores /></ProtectedRoute>} />
          <Route path="/course/simulador-hash" element={<ProtectedRoute account={account} loading={loading}><HashSimulator /></ProtectedRoute>} />
          <Route path="/course/simulador-bloques" element={<ProtectedRoute account={account} loading={loading}><BlockSimulator /></ProtectedRoute>} />
          <Route path="/course/simulador-red" element={<ProtectedRoute account={account} loading={loading}><BlockSimulatorNetwork /></ProtectedRoute>} />
          <Route path="/course/simulador-tx-chain" element={<ProtectedRoute account={account} loading={loading}><TxChainSimulator /></ProtectedRoute>} />
          <Route path="/course/simulador-gas" element={<ProtectedRoute account={account} loading={loading}><GasPriorityChain /></ProtectedRoute>} />
          <Route path="/course/simulador-mempool" element={<ProtectedRoute account={account} loading={loading}><MerkleMempoolSimulation /></ProtectedRoute>} />
          <Route path="/course/simulador-billeteras" element={<ProtectedRoute account={account} loading={loading}><Billeteras /></ProtectedRoute>} />

          {/* Libros */}
          <Route path="/course/libro/:slug/leccion/:lessonSlug" element={<ProtectedRoute account={account} loading={loading}><LessonView /></ProtectedRoute>} />
          <Route path="/course/books" element={<ProtectedRoute account={account} loading={loading}><Books /></ProtectedRoute>} />
          <Route path="/course/books/:slug" element={<ProtectedRoute account={account} loading={loading}><BookDetail /></ProtectedRoute>} />
          <Route path="/course/reader/:slug" element={<ProtectedRoute account={account} loading={loading}><Reader /></ProtectedRoute>} />
          <Route path="/course/reader/:slug/:chapterIndex" element={<ProtectedRoute account={account} loading={loading}><Reader /></ProtectedRoute>} />

          {/* Clases */}
          <Route path="/course/clases" element={<ProtectedRoute account={account} loading={loading}><RedirectToFirstClass /></ProtectedRoute>} />
          <Route path="/course/clases/:classId" element={<ProtectedRoute account={account} loading={loading}><FiveClassesViewer /></ProtectedRoute>} />

          {/* Solidity book */}
          <Route path="/course/solidity-book/:contentId" element={<ProtectedRoute account={account} loading={loading}><ContentViewerSolidity /></ProtectedRoute>} />
          <Route path="/course/solidity-book" element={<Navigate to="/course/solidity/1" replace />} />


          {/* ===== Fundamentos de Blockchain ===== */}
          <Route
            path="/course/blockchain-fundamentos/:contentId"
            element={
              <ProtectedRoute account={account} loading={loading}>
                <ContentViewerBlockchain />
              </ProtectedRoute>
            }
          />
          <Route
            path="/course/blockchain-fundamentos"
            element={<Navigate to="/course/blockchain-fundamentos/1" replace />}
          />


          {/* ===== Libro de Tokens ===== */}
          <Route
            path="/course/token/:contentId"
            element={
              <ProtectedRoute account={account} loading={loading}>
                <ContentViewerTokens />
              </ProtectedRoute>
            }
          />
          <Route
            path="/course/token"
            element={<Navigate to="/course/token/1" replace />}
          />

          {/* ===== Libro de Cryptonomics ===== */}
          <Route
            path="/course/cryptonomics/:contentId"
            element={
              <ProtectedRoute account={account} loading={loading}>
                <ContentViewerCryptonomics />
              </ProtectedRoute>
            }
          />
          <Route
            path="/course/cryptonomics"
            element={<Navigate to="/course/cryptonomics/1" replace />}
          />

          {/* ===== Libro de Santochi ===== */}
          <Route
            path="/course/bitcoin-growth/:contentId"
            element={
              <ProtectedRoute account={account} loading={loading}>
                <ContentViewerSatoshi />
              </ProtectedRoute>
            }
          />
          <Route
            path="/course/bitcoin-growth"
            element={<Navigate to="/course/bitcoin-growth/1" replace />}
          />

          {/* ===== Libro de DArkForest ===== */}
          <Route
            path="/course/dark-forest/:contentId"
            element={
              <ProtectedRoute account={account} loading={loading}>
                <ContentViewerDarkForest />
              </ProtectedRoute>
            }
          />
          <Route
            path="/course/dark-forest"
            element={<Navigate to="/course/dark-forest/1" replace />}
          />


          {/* ===== Fundamentos Esenciales de Blockchain ===== */}
          <Route
            path="/course/blockchain-fundamentos-esenciales/:contentId"
            element={
              <ProtectedRoute account={account} loading={loading}>
                <ContentViewerBlockchainEsencial />
              </ProtectedRoute>
            }
          />
          <Route
            path="/course/blockchain-fundamentos-esenciales"
            element={
              <Navigate
                to="/course/blockchain-fundamentos-esenciales/1"
                replace
              />
            }
          />


          {/* ===== Bitcoin: De Cero a Avanzado ===== */}
          <Route
            path="/course/bitcoin-master/:contentId"
            element={
              <ProtectedRoute account={account} loading={loading}>
                <ContentViewerBitcoinMaster />
              </ProtectedRoute>
            }
          />

          <Route
            path="/course/bitcoin-master"
            element={
              <Navigate
                to="/course/bitcoin-master/1"
                replace
              />
            }
          />

          {/* ===== Cryptomoendas Book ===== */}
          <Route
            path="/course/criptomonedas-fundamentales/:contentId"
            element={
              <ProtectedRoute account={account} loading={loading}>
                <ContentViewerCryptomonedas />
              </ProtectedRoute>
            }
          />

          <Route
            path="/course/criptomonedas-fundamentales"
            element={
              <Navigate
                to="/course/criptomonedas-fundamentales/1"
                replace
              />
            }
          />




          {/* Certificados */}
          <Route path="/course/mint-certificate" element={<ProtectedRoute account={account} loading={loading}><PDF /></ProtectedRoute>} />
          <Route path="/course/NFT-certificate" element={<ProtectedRoute account={account} loading={loading}><NFTC /></ProtectedRoute>} />
          <Route path="/course/my-NFTs" element={<ProtectedRoute account={account} loading={loading}><NFTCo /></ProtectedRoute>} />


          <Route
            path="/course/diccionario"
            element={
              <ProtectedRoute account={account} loading={loading}>
                <CryptoDictionaryABC />
              </ProtectedRoute>
            }
          />

          <Route path="/course/:bookId/:slug" element={<BookPage />} />
          <Route path="/course/:bookId" element={<BookPage />} />


          {/* Fallback opcional: 404 */}
          {/* <Route path="*" element={<NotFound />} /> */}
        </Routes>
      </div>

      {/* Footer solo cuando NO esté en rutas sin footer */}
      {!hideChrome && !hideFooter && <Footer />}
    </div>
  );
}

export default AppWrapper;
